/**
 * 客户端通信bridge
 */
define('util/client-bridge',[],function() {
    /**
     * 不是直接location.href = uri，
     * 是因为在Ios浏览器里面连续短时间两次设置location.href，
     * 会导致浏览器认为应该location到后面那次，
     * 后面那次覆盖掉了前面那次请求
     */
    var _call = function(uri) {
        if (CLIENT_DATA.os === 'android' && CLIENT_DATA.client === 'kn') {
            // 卡牛客户端问题，回退在部分机型无法加载iframe中的url scheme
            window.location.href = uri;
        } else {
            var iframe = document.createElement('iframe');
            iframe.src = uri;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            var cb = function() {
                setTimeout(function() {
                    document.body.removeChild(iframe);
                }, 1000);
            };
            iframe.onload = cb;
            iframe.onerror = cb;
        }
    };
    /**
     * 随手记协议拼接方法
     * @MethodName：方法名
     * @JSONParamString：参数
     * @CallBackName：回调函数
     * @ExtraString：其他信息
     */
    var uriSuishouji = function(MethodName, JSONParamString, CallBackName, ExtraString) {
        var cmd = 'feidee://Market/' + MethodName;
        var params = [];
        if (JSONParamString) {
            params.push('p=' + encodeURIComponent(JSON.stringify(JSONParamString)));
        }
        if (CallBackName) {
            params.push('cb=' + CallBackName);
        }
        if (ExtraString) {
            params.push('e=' + ExtraString);
        }
        var uri = cmd + (params.length > 0 ? '?' + params.join('&') : '');
        return uri;
    };
    /**
     * 随管家协议拼接方法
     * @data: 参数
     * @callbac: 回调函数
     */
    var callSuiguanjia = function(uri, JsonParam, CallBackName) {
      var jp = JsonParam || {};
      var params = [];
      var keys = Object.keys(jp);


      keys.forEach(function(k) {
        var value = JsonParam[k];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
         }
          value = encodeURIComponent(value);
          params.push(k + '=' + value);
        });

      if (CallBackName) {
        params.push('cb=' + CallBackName);
      }

      return uri + (params.length > 0 ? '?' + params.join('&') : '');
    };
    /**
     * H5与客户端通信桥，适用于随手记，卡牛
     * @param {string} uri
     * @param {string} callbackName
     * @param {function} callback
     */
    var call = function(uri, callbackName, callback) {
        if (callbackName) {
            window[callbackName] = callback;
        }
        _call(uri);
    };
    return {
        call: call,
        uriSuishouji: uriSuishouji,
        callSuiguanjia: callSuiguanjia
    };
});

